//쿠키 호출
import { cookies } from './cookies';
var setFunction;
var loadingCount = 0;
const hashLoginPage = '#/member/login';

export const ajaxFrame = {
	ajaxSessionCheck:function() {
        alert('로그인 세션이 만료되었습니다.');
        document.location.hash= '#/member/login';
        location.href = '#/member/login';
	},
	ajaxHtmlCall:function(id, type, dataUrl, dataType, async, callBack) {
		var hashParam = document.location.hash;
		if((cookies.getCookies('user_id') == null) && (hashParam != hashLoginPage)) {
			this.ajaxSessionCheck();
		}else{
			$.ajax({
				type: type ,
				url:dataUrl ,
				dataType : dataType,
				async:async,
				success: function(data) {
					$(id).html(data);
					if(callBack !== undefined) {
						callBack();
						loadingCount = 0;
					}
				},
				error:function() {
					if(loadingCount < 10) {
						loadingCount++;
						ajaxFrame.ajaxHtmlCall(id, type, dataUrl, dataType, async, callBack);
					}else{
						alert('페이지를 불러올 수 없습니다.');
						return;
					}
				}
			});
		}
	},
	ajaxDataCall:function(type, dataUrl, dataType, async, callBack, data, etc) {
		var hashParam = document.location.hash;
		if((cookies.getCookies('user_id') == null) && (hashParam != hashLoginPage)) {
			this.ajaxSessionCheck();
		}else{
			$.ajax({
				type: type ,
				url:dataUrl ,
				data: JSON.stringify(data),
				dataType : dataType,
				async:async,
				contentType: "application/json; charset=utf-8",
				xhrFields: {
					withCredentials: true
				},
				success: function(data) {
					if(data.success == false) {
						if(data.msg != null) {
							alert(data.msg);
						}
					}else{
						callBack(data, etc);
						loadingCount = 0;
					}
				},
				error:function() {
					if(loadingCount < 10) {
						loadingCount++;
						ajaxFrame.ajaxDataCall(type, dataUrl, dataType, async, callBack, data, etc);
					}else{
						console.error('접속 에러')
						return;
					}
				}
			});
		}
	},
	ajaxAppendCall:function(id, type, dataUrl, dataType, async, callBack, callType) {
		var hashParam = document.location.hash;
		if((cookies.getCookies('user_id') == null) && (hashParam != hashLoginPage)) {
			this.ajaxSessionCheck();
		}else{
			$.ajax({
				type: type ,
				url:dataUrl ,
				dataType : dataType,
				async:async,
				success: function(data) {
					$(id).parent('*').append(data);
					if(callBack !== undefined) {
						callBack(callType);
					}
				},
				error:function() {
					alert('페이지를 읽을 수 없습니다.');
				}
			});
		}
	}
}



// WEBPACK FOOTER //
// ./js/controller/assets/lib/ajaxForm.js